var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmexCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73677 0H26.0519C27.0107 0 27.7887 0.779061 27.7887 1.73989V18.261C27.7887 19.2209 27.0107 20 26.0519 20H1.73677C0.777189 20.0001 0 19.2209 0 18.2611V1.73989C0 0.779061 0.778047 0 1.73677 0Z",
    fill: "#26A6D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48635 6.95703L1.74219 13.0377H5.02734L5.4346 12.0682H6.36551L6.77278 13.0377H10.3888V12.2977L10.711 13.0377H12.5815L12.9037 12.2821V13.0377H20.4241L21.3385 12.0934L22.1947 13.0377L26.0574 13.0455L23.3045 10.0143L26.0574 6.95703H22.2547L21.3645 7.88391L20.5352 6.95703H12.3541L11.6515 8.5265L10.9325 6.95703H7.65426V7.67181L7.28957 6.95703H4.48635ZM5.12201 7.82049H6.72334L8.54355 11.9438V7.82049H10.2977L11.7036 10.7769L12.9993 7.82049H14.7448V12.1838H13.6827L13.674 8.76473L12.1257 12.1838H11.1756L9.61857 8.76473V12.1838H7.43367L7.01946 11.2056H4.78161L4.36825 12.1829H3.19761L5.12201 7.82049ZM15.7165 7.82049H20.035L21.3558 9.2491L22.7193 7.82049H24.0401L22.0332 10.0135L24.0401 12.1812H22.6593L21.3385 10.736L19.9681 12.1812H15.7165V7.82049ZM5.90101 8.55874L5.16373 10.3013H6.63743L5.90101 8.55874ZM16.7829 8.72391V9.52043H19.1389V10.4082H16.7829V11.2778H19.4254L20.6533 9.99698L19.4775 8.72315H16.7829V8.72391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexCardLogo);
export default __webpack_public_path__ + "static/media/amex_card_logo.67748bffc7c4546359017179ea542e2a.svg";
export { ForwardRef as ReactComponent };